import WorkspaceMeetingModeSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceMeetingMode.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';
import { showNotificationError } from 'Shared/helpers';

import WorkspaceMeetingModeConstants from '../constants/WorkspaceMeetingMode.constants';
import * as WorkspaceMeetingModeAPI from '../api/WorkspaceMeetingMode.api';

export const fetchMeetingModeStatusSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.FETCH_MEET_MODE_SUCCESS,
  payload,
});

export const startMeetingModeSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.START_MEET_MODE_SUCCESS,
  payload,
});

export const leaveMeetingModeSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.LEAVE_MEET_MODE_SUCCESS,
  payload,
});

export const updateMeetingModeSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.UPDATE_MEET_MODE_SUCCESS,
  payload,
});

export const actionCableUpdateMeetingModeSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.ACTION_CABLE_UPDATE_SUCCESS,
  payload,
});

export const dismissParticipantPopoverSuccess = payload => ({
  type: WorkspaceMeetingModeConstants.Actions.DISMISS_PARTICIPANT_POPOVER_SUCCESS,
  payload,
});

export const fetchMeetingModeStatus = workspaceUuid => dispatch => {
  return WorkspaceMeetingModeAPI.fetchMeetingMode(workspaceUuid)
    .then(response => {
      dispatch(fetchMeetingModeStatusSuccess(normalizer(WorkspaceMeetingModeSchema, response.data)));
      return response;
    })
    .catch(error => {
      return error.response.data.error;
    });
};

export const startMeetingMode = workspaceUuid => dispatch => {
  return WorkspaceMeetingModeAPI.startMeetingMode(workspaceUuid)
    .then(response => {
      dispatch(startMeetingModeSuccess(normalizer(WorkspaceMeetingModeSchema, response.data)));
      return response;
    })
    .catch(error => {
      if (error.response.data.error !== 'Add a discussion topic to this workspace to start meeting mode.') {
        showNotificationError(error);
      }
      return error.response.data.error;
    });
};

/**
 *  (josh)
 *  deprecated with introduction of meeting mode v2
 *  use updateMeetingModeV2 wich passes an itemUuid to switch to
 */
export const updateMeetingMode = (workspaceUuid, direction) => dispatch => {
  const params = {
    [WorkspaceMeetingModeConstants.Params.UPDATE]: direction,
  };

  return WorkspaceMeetingModeAPI.updateMeetingMode(workspaceUuid, params)
    .then(response => {
      dispatch(updateMeetingModeSuccess(normalizer(WorkspaceMeetingModeSchema, response.data)));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateMeetingModeV2 = (workspaceUuid, data) => dispatch => {
  return WorkspaceMeetingModeAPI.updateMeetingModeV2(workspaceUuid, data)
    .then(response => {
      dispatch(updateMeetingModeSuccess(normalizer(WorkspaceMeetingModeSchema, response.data)));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const leaveMeetingMode = workspaceUuid => dispatch => {
  return WorkspaceMeetingModeAPI.leaveMeetingMode(workspaceUuid)
    .then(response => {
      dispatch(leaveMeetingModeSuccess(workspaceUuid));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const dismissParticipantPopover = meetingModId => dispatch => {
  dispatch(dismissParticipantPopoverSuccess(meetingModId));
};
